import { RankGradeLookup } from './lookups-utils';

export const formatRankGrade = (rankCode: string, gradeCode: string, suppressRank = false) => {
	return suppressRank ? gradeCode : `${rankCode}/${gradeCode}`;
};

export const formatRankGradeFromLookup = (gradeLookup: RankGradeLookup, gradeOid: string) => {
	const grade = gradeLookup[gradeOid],
		rank = grade && grade.rank;

	if (!grade) {
		return;
	}

	return formatRankGrade(rank.code, grade.grade.code);
};

export const formatRankNameFromLookup = (gradeLookup: RankGradeLookup, gradeOid: string) => {
	const grade = gradeLookup[gradeOid],
		rank = grade && grade.rank;

	if (!grade) {
		return;
	}

	return rank.desc;
};

export const formatGradeNameFromLookup = (gradeLookup: RankGradeLookup, gradeOid: string) => {
	const grade = gradeLookup[gradeOid];
	if (!grade) {
		return;
	}

	return grade.grade.desc;
};

export const formatRankGradesDisplay = (
	gradeLookup: RankGradeLookup,
	fromGradeOid: string,
	toGradeOid: string,
	preferredGradeOid?: string,
) => {
	const fromGrade = gradeLookup[fromGradeOid],
		toGrade = gradeLookup[toGradeOid],
		prefGrade = preferredGradeOid && gradeLookup[preferredGradeOid],
		fromRank = fromGrade && fromGrade.rank,
		toRank = toGrade && toGrade.rank,
		prefRank = prefGrade && prefGrade.rank;

	if (!fromGrade || !toGrade) {
		return;
	}

	let result = `${formatRankGrade(fromRank.code, fromGrade.grade.code)} - ${formatRankGrade(
		toRank.code,
		toGrade.grade.code,
		fromRank == toRank,
	)}`;

	if (prefGrade && prefRank) {
		result += ` (${formatRankGrade(prefRank.code, prefGrade.grade.code, fromRank == prefRank)})`;
	}
	return result;
};
